import type { StorefrontOptionsEnvelope } from '../api';
import { parseStoredSparkOptions } from '../schemas';
import type { SparkOptions } from '../types/spark-options';
import { isPlainObject } from './object';
import { toSparkJsOptions } from './sparkjs-options';

export function decodeSparkOptions(envelope: StorefrontOptionsEnvelope): SparkOptions {
  let raw: unknown;
  try {
    raw = envelope.value ? JSON.parse(envelope.value) : undefined;
  } catch {
    raw = undefined;
  }

  return parseStoredSparkOptions(isPlainObject(raw) ? raw : {});
}

export function encodeSparkOptions(options: SparkOptions): StorefrontOptionsEnvelope {
  return { value: JSON.stringify(toSparkJsOptions(options)) };
}

export function defaultSparkOptions(): SparkOptions {
  return parseStoredSparkOptions({});
}
